import React, { useState } from 'react';

interface Props {
  text: string;
}

const CopyToClipboardButton: React.FC<Props> = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed', err);
    }
  };

  return (
    <button
      className="btn btn-secondary ms-2 mt-3"
      onClick={handleCopy}
      disabled={copied}
    >
      {copied ? 'Kopiert!' : 'In Zwischenablage kopieren'}
    </button>
  );
};

export default CopyToClipboardButton;
